import { render, staticRenderFns } from "./CodeView.vue?vue&type=template&id=09b6d7f2&scoped=true&"
import script from "./CodeView.vue?vue&type=script&lang=js&"
export * from "./CodeView.vue?vue&type=script&lang=js&"
import style0 from "./CodeView.vue?vue&type=style&index=0&id=09b6d7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b6d7f2",
  null
  
)

export default component.exports